import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAppDispatch } from "../../store/hooks";
import { loginThunk } from "../../store/features/auth/authSlice";
import classes from "./styles.module.scss";
import { InputField } from '../../components/InputField';
import { MainButton } from '../../components/MainButton';
import { showNotification } from "../../store/features/notifications/notificationSlice";


export const SignInPage = () => {

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState<string | null>(null);
  const [passwordError, setPasswordError] = useState<string | null>(null);

  const handleSubmit = (e: React.FormEvent) => {
      e.preventDefault();
      dispatch(loginThunk({ email, password }))
        .unwrap()
        .then(() => {
          //navigate("/");
          dispatch(showNotification({ message: "Signed in sccesfully.", type: "success" }));
          navigate("/");
        })
        .catch(() => {
          dispatch(showNotification({ message: "Failed to sign in.", type: "error" }));
        });
    };

  return (
    <div className={classes.RegisterPage}>
      <div className={classes.contentWrapper}>
        <div className={classes.logo} onClick={() => navigate("/")} >.shortform</div>
        <div className={classes.infoWrapper}>
          <h2>Sign in to your account</h2>
          <div className={classes.infoText}>
            <p>Don't have an account? <a href="" onClick={() => navigate("/register")}>Sign up</a> for an account now.</p>
          </div>
        </div>
        <div className={classes.breakLine}>
          <div className={classes.midLine}></div>
          <span>or</span>
          <div className={classes.midLine}></div>
        </div>
        <div className={classes.formWrapper}>
          <InputField label='Email' role='email' value={email} onChange={(e) => setEmail(e.target.value)} onValidationError={setEmailError} />
          <InputField label='Password' type="password" role='password' value={password} onChange={(e) => setPassword(e.target.value)} onValidationError={setPasswordError} />
          <a href="" onClick={() => navigate("/forgotpassword")}>Forgot your password?</a>
          <MainButton title='Sign in' icon="chevronRight" variant='primary' fullWidth onClick={handleSubmit} disabled={!email || !password || !!emailError || !!passwordError} />
        </div>
      </div>
    </div>
  )
}

export default SignInPage